import type {EventsTabProfileListOverrides} from "~/components/entityProfile/eventsTabProfileListOverrides";
import type {ProfileTabRenderProps} from "~/components/entityProfile/types";
import {EventsTab} from "~/routes/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/w/$workspaceId/ottopilot/_ottopilotScaffold/event-containers/$eventContainerId/index/-eventsTab";
import type {EventContainerWithEvents} from "~/utilities/apis/api";

export function ProfileEventsTabContent({
    tabRenderProps,
    journey,
    dismissFooterEngagementPanels,
    registerDismissEventRowEngagement,
    profileListOverrides,
}: {
    tabRenderProps: ProfileTabRenderProps;
    journey: EventContainerWithEvents;
    dismissFooterEngagementPanels: () => void;
    registerDismissEventRowEngagement: (dismiss: () => void) => void;
    profileListOverrides?: EventsTabProfileListOverrides;
}) {
    if (tabRenderProps.kind !== "journey") {
        return null;
    }

    return (
        <div className="h-full min-h-0 overflow-hidden">
            <EventsTab
                journey={journey}
                presentation="profile"
                className="h-full min-h-0"
                dismissFooterEngagementPanels={dismissFooterEngagementPanels}
                registerDismissEventRowEngagement={registerDismissEventRowEngagement}
                profileListOverrides={profileListOverrides}
            />
        </div>
    );
}
